/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GiornoDellaSettimanaEnum } from './giorno-della-settimana-enum';
import { ServizioMensaChiusuraScolasticaDTO } from './servizio-mensa-chiusura-scolastica-dto';


export interface ServizioMensaCalendarioScolasticoDTO { 
    data_inizio?: string;
    data_fine?: string;
    chiusure_scolastiche?: Array<ServizioMensaChiusuraScolasticaDTO>;
    chiusure_settimanali?: Array<GiornoDellaSettimanaEnum>;
}

